
import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: 'What is a VPN and why do I need one?',
      answer: 'A VPN (Virtual Private Network) creates a secure, encrypted connection between your device and the internet. It protects your privacy by hiding your IP address, encrypting your data, and preventing third parties from tracking your online activities. You need a VPN to secure your personal information, access geo-restricted content, and maintain anonymity online.'
    },
    {
      question: 'How does DINARCO VPN protect my privacy?',
      answer: 'DINARCO VPN uses military-grade AES-256 encryption to secure all your internet traffic. We maintain a strict no-logs policy, meaning we never track, collect, or store your browsing history, connection logs, or any personal data. Your online activities remain completely private and anonymous.'
    },
    {
      question: 'Can I use DINARCO VPN on multiple devices?',
      answer: 'Yes! DINARCO VPN supports multiple devices simultaneously. You can protect your laptop, smartphone, tablet, and other devices all at once with a single account. Our apps are available for Windows, macOS, iOS, Android, and Linux.'
    },
    {
      question: 'Will using a VPN slow down my internet connection?',
      answer: 'While VPNs can slightly reduce speed due to encryption overhead, DINARCO VPN is optimized for performance. Our global network of high-speed servers ensures minimal impact on your connection speed. Most users experience fast, reliable connections suitable for streaming, gaming, and downloading.'
    },
    {
      question: 'Is it legal to use a VPN?',
      answer: 'Yes, using a VPN is legal in most countries, including Argentina and the United States. VPNs are legitimate tools for protecting privacy and security online. However, using a VPN to engage in illegal activities remains illegal regardless of the VPN usage.'
    },
    {
      question: 'How do I get started with DINARCO VPN?',
      answer: 'Getting started is easy! Simply contact us through our contact form or support channels, and our team will guide you through the setup process. We provide detailed instructions and support to help you install and configure DINARCO VPN on all your devices.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold tracking-wider uppercase text-gray-600">FREQUENTLY ASKED QUESTIONS</span>
          <h2 className="text-5xl font-bold text-gray-900 mt-4 font-serif">Everything You Need to Know</h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl overflow-hidden transition-all hover:shadow-md"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-8">{faq.question}</h3>
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                  <i
                    className={`${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    } text-purple-600 text-2xl transition-transform w-6 h-6 flex items-center justify-center`}
                  ></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
